import { gql } from '@apollo/client';

import {
  SubmitFormDocument,
  type SubmitFormMutation,
  type SubmitFormMutationVariables,
} from '../__generated__/documents';

if (false) {
  gql`
    mutation SubmitForm($input: SubmitFormInput!) {
      submitForm(input: $input) {
        success
        message
        surveyProgress
      }
    }
  `;
}

export const SUBMIT_FORM = SubmitFormDocument;
export type { SubmitFormMutation, SubmitFormMutationVariables };
